import React from 'react'
import { Chip } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { getRfidChipColors, getRfidChipLabel, getRfidChipStatus } from '../../utils'

/** Badge component for displaying RFID expiration date / status */
export const RfidCardExpirationChip: React.FC<{ expirationDate: string | null | undefined }> = ({ expirationDate }) => {
  const { t } = useCustomTranslation()

  if (!expirationDate) return null

  const status = getRfidChipStatus(expirationDate)
  const label = getRfidChipLabel(status, expirationDate, t)
  const { color, bgcolor } = getRfidChipColors(status)

  return <Chip size="small" label={label} sx={{ bgcolor, color }} />
}
